import { Table } from 'ui/table/Table';
import { StatusTableItem } from 'ui/statusTableItem/StatusTableItem';
import { ReactComponent as YesIcon } from 'assets/icons/yes.svg';
import { ReactComponent as NoIcon } from 'assets/icons/no.svg';

import { UsersTableRowProps } from './UsersTableRow.types';

export const UsersTableRow = ({ user }: UsersTableRowProps) => {
  return (
    <>
      <Table.RowItem>{user.username}</Table.RowItem>

      <Table.RowItem>{`${user.nazwisko} ${user.imie}`}</Table.RowItem>

      <Table.RowItem>{user.zalogowany ? <YesIcon /> : <NoIcon />}</Table.RowItem>

      <Table.RowItem>
        <StatusTableItem status={user.status} smallFontSize />
      </Table.RowItem>
    </>
  );
};
